export default {
  'company': {
    'key': 'company',
    'name': '所在企业',
    'required': true,
    'regName': 'checkIsEmpty'
  },
  'job_title': {
    'key': 'job_title',
    'name': '职位',
    'required': true,
    'regName': 'checkIsEmpty'
  },
  'job_title_content': {
    'key': 'job_title_content',
    'name': '',
    'subName': '请填写您的职位名称 (选填）',
    'required': false
  },
  'company_industry': {
    'key': 'company_industry',
    'name': '行业领域',
    'required': true,
    'regName': 'checkIsEmpty'
  },
  'company_type': {
    'key': 'company_type',
    'name': '融资阶段',
    'required': true,
    'regName': 'checkIsEmpty'
  },
  'company_scale': {
    'key': 'company_scale',
    'name': '企业规模（人数）',
    'required': true,
    'regName': 'checkIsEmpty'
  },
  'company_remark': {
    'key': 'company_remark',
    'name': '备注',
    'layout': 'compaction'
  },
  'company_develop': {
    'key': 'company_develop',
    'name': '企业研发团队规模（人数）',
    'required': true,
    'regName': 'checkIsEmpty'
  },
  'managed_team_size': {
    'key': 'managed_team_size',
    'name': '本人现带领团队规模（人数）',
    'required': true,
    'regName': 'checkIsEmpty'
  },
  'development_team_size': {
    'key': 'development_team_size',
    'name': '本人曾带领团队最大规模（人数）',
    'required': true,
    'regName': 'checkIsEmpty'
  },
  'developed_start_year': {
    'key': 'developed_start_year',
    'name': '从事研发工作起始年',
    'required': true,
    'regName': 'checkIsEmpty'
  },
  'managed_start_year': {
    'key': 'managed_start_year',
    'name': '从事管理工作起始年',
    'required': true,
    'regName': 'checkIsEmpty'
  },
  'study_experience': {
    'key': 'study_experience',
    'name': '教育经历',
    'required': true,
    'regName': 'checkIsEmpty',
    'placeholder': '（包括学历，请将自己所获荣誉、职称、图书出版一并填写）\n2010-2014 浙江大学计算机系，学士\n2014-2016 北京大学人工智能系，硕士\n2016-2020 清华大学人工智能系，博士\n2021年 出版图书《知行合一：一个草根创业者的40岁复盘》\n2024年 全国工商联人工智能委员会委员\n2025年 获评为北京市朝阳区凤凰人才'
  },
  'work_experience': {
    'key': 'work_experience',
    'name': '工作经历',
    'required': true,
    'regName': 'checkIsEmpty',
    'placeholder': '2001-2002年浙江万方计算机软件有限公司\n2002-2004年深圳新思维软件杭州研发基地\n2004-2007年中国软件开发网\n2007-至今北京极客邦科技'
  },
  'support_resource': {
    'key': 'support_resource',
    'name': '可提供的资源',
    'required': true,
    'regName': 'checkIsEmpty'
  },
  'want_resource': {
    'key': 'want_resource',
    'name': '期望获得的价值',
    'required': true,
    'regName': 'checkIsEmpty'
  },
  'achievements': {
    'key': 'achievements',
    'name': '项目经历',
    'required': true,
    'regName': 'checkIsEmpty',
    'placeholder': '（请详细描述，有利于后期匹配更精准的资源）\n2007年创立InfoQ中文站，将InfoQ这一全球知名的技术社区引入中国，目前已经成为中高端技术人员获取技术资讯的主要可信源之一\n2009年引入QCon全球软件开发大会，邀请包括Martin Fowler、Rod Johnson等国际知名专家来中国分享，有力促进了中国互联网产业的发展\n2015年创立TGO鲲鹏会，目前全球13个城市设立分会，累积会员超过2300名，已经成为全球范围内最活跃、最规范的科技领导者组织\n2017年创立极客时间，到目前为止已经超过330万会员，累计服务超过4000多家企业，有效促进了个人IT能力提升和企业数字化转型'
  },
  // 个人中心默认选填；申请流程在 form-detail/info-config 与 form-combined 里覆盖为必填
  'education': {
    'key': 'education',
    'name': '最高学历',
    'required': false
  },
  'school_region': {
    'key': 'school_region',
    'name': '最高学历学校所在地',
    'required': false
  }
}
